// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserSchema } from './v1/userSchema';

export const getUserPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  id: z.number().int().describe("User id"),
});

export const getUserHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description user details
 */
export const getUser200Schema = z.lazy(() => v1UserSchema);

export const getUserQueryResponseSchema = z.lazy(() => getUser200Schema);
